import React from 'react'
import {View, Text, StyleSheet} from '@react-pdf/renderer';

const MeterView = ({meter}) => {
    return(
        <View wrap={false} style={{marginTop: 5, marginBottom: 5}}>
            <Text style={styles.text}>
                {meter.meterType_fi_FI}
            </Text>
            {meter.meterValueType === "REALIZED" &&
            <Text style={styles.text}>
                Edistyminen: Mittari {meter.currentLevel === "realized" ? "on toteutunut" : "ei ole toteutunut"}
            </Text>}
            {meter.meterValueType === "NUMBER" &&
            <View style={styles.flexRow}>
                <Text style={styles.textWithMargin}>Lähtötaso: {meter.startingLevel}</Text>
                <Text style={styles.textWithMargin}>Nykyinen taso: {meter.currentLevel}</Text>
                <Text style={styles.textWithMargin}>Tavoitetaso: {meter.targetLevel}</Text>
            </View>}
        </View>
    )
}

export default MeterView

const styles = StyleSheet.create({
    text: {
        fontSize: 10,
    },
    textWithMargin: {
        fontSize: 10,
        marginRight: 5,
    },
    flexRow: {
        display: "flex",
        flexDirection: "row",
    }
})


// WEBPACK FOOTER //
// ./src/components/printable/MeterView.jsx